module.exports = __webpack_public_path__ + "static/media/delete.2b735f00.svg";